module.exports = __webpack_public_path__ + "fonts/fa-brands-400.099a9556.woff";